import { productListStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationProductList";
import { css } from "styled-components";

productListStyles.orderLinesList = {
    cardExpanded: {
        container: {
            css: css`
                div[class^="GridOffset"] {
                    width: calc(100% + 10px);
                }
            `,
        },
    },
};
